import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  companyId: z.number().optional(),
  returnUrl: z.string().optional()
})

export const bankAccountEditRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `$bankAccountId/edit`,
    component: lazyRouteComponent(() => import('./Edit')),
    validateSearch: (search: Record<string, unknown>) => searchSchema.parse(search)
  })
